const AnimatedLoading = () => {
  const text = "Loading...";

  return (
    <div className="flex items-center justify-center m-1">
      <div className="flex text-base font-semibold">
        {text.split("").map((char, index) => (
          <span
            key={index}
            className="animate-bounce text-neutral-500"
            style={{
              animationDelay: `${index * 0.1}s`,
              animationDuration: "1s",
            }}
          >
            {char === " " ? "\u00A0" : char}
          </span>
        ))}
      </div>
    </div>
  );
};

export { AnimatedLoading };
